export default __webpack_public_path__ + "static/media/24.06208950.png";